let currentPixiApp = null;
export let pixiApp;

const loadAssetsPixi = () =>
  import("./assetsLoad.js")
    .then(({ default: loadAssets }) => {
      return loadAssets()
    })
    .catch((error) => {
      console.error("Error during assets loading in Pixi:", error);
      throw error;
    });


const loadPixiApp = () =>
  import("./appPixi.js")
    .then(({ default: createPixiApp }) => {
      if (currentPixiApp) {
        currentPixiApp.destroyPixi(true);
      }

      pixiApp = createPixiApp();
      currentPixiApp = pixiApp;
      return pixiApp;
    })
    .catch((error) => {
      console.error("Error during Pixi.js initialization:", error);
      throw error;
    });

const createLoadingBar = () =>
  import("./assetsProgressBar.js")
    .then(({ createProgressBar }) => {
      createProgressBar(currentPixiApp)
    })
    .catch((error) => {
      console.error("Error loading assetsLoadBar.js:", error);
      throw error;
    });


const loadGameUI = (setIsPixiAssetsLoaded) =>
  import("./gameUI.js")
    .then(({ createAppUI }) => {
      createAppUI(setIsPixiAssetsLoaded)
    })
    .catch((error) => {
      console.error("Error loading gameUI.js:", error);
      throw error;
    });

let gameLogicModule;

export const loadGameLogicFunctions = () => {
  if (!gameLogicModule) {
    return import('./gameLogic.js')
      .then((module) => {
        gameLogicModule = module;
        return gameLogicModule;
      })
      .catch((error) => {
        console.error('Error loading ameLogic.js:', error);
        throw error;
      });
  }

  return Promise.resolve(gameLogicModule);
};


const gameTickerStart = () =>
  loadGameLogicFunctions(gameLogicModule)
    .then((gameLogicModule) => {
      gameLogicModule.startGameTicker()
    })
    .catch((error) => {
      console.error("Error loading gameLogic.js:", error);
      throw error;
    });


export const loadPixiAssets = () =>
  loadAssetsPixi()
    .then(() => console.log())
    .catch((error) => {
      console.error("Error loading pixi assets:", error);
    });

export const destroyPixiApp = () =>
  loadGameLogicFunctions(gameLogicModule)
    .then((gameLogicModule) => {
      gameLogicModule.stopGameTicker()
    })
    .then(destroyPixiAppliaction)
    .catch((error) => {
      console.error("Error destroying pixi:", error);
    });

function destroyPixiAppliaction () {
  if (currentPixiApp) {
    currentPixiApp.destroyPixi(true);
    currentPixiApp = null;
  }
}

export const resizePixiApp = (x, y) => currentPixiApp.resizePixiApp(x, y)

export const init = (setIsPixiAssetsLoaded) =>
  loadPixiApp()
    .then(() => createLoadingBar())
    .then(() => loadAssetsPixi())
    .then(() => loadGameUI(setIsPixiAssetsLoaded))
    .then(() => gameTickerStart())
    .catch((error) => {
      console.error("Error during Pixi initialization:", error);
    });

let gameUIModule;

export const loadGameUIFunctions = () => {
  if (!gameUIModule) {
    return import('./gameUI.js')
      .then((module) => {
        gameUIModule = module;
        return gameUIModule;
      })
      .catch((error) => {
        console.error('Error loading ameUI.js:', error);
        throw error;
      });
  }

  return Promise.resolve(gameUIModule);
};
